<!-- 增加了动态绑定disabled功能 -->
<template>
  <van-cell-group :title="label">
    <!-- <van-field v-model="selectValue" label="" placeholder="请输入其他备案执业地点"></van-field> -->
    <van-radio-group v-model="selectValue"  direction="horizontal" @change="change">
      <van-radio name="是">是</van-radio>
      <van-radio name="否">否</van-radio>
    </van-radio-group>
  </van-cell-group>
</template>

<script>
  export default {
    //科室表单下拉列表
    name: 'enterGroupRadio',
    data() {
      return {
        selectValue: this.value
      }
    },
    props: {
      value: {},
      // 增加了动态绑定disabled功能
      disabled: {

      },
      label:{
        type:String,
        default:""
      }
    },
    methods: {
      change: function() {
		  console.log( this.selectValue)
        this.$emit('input', this.selectValue)
      }
    },
    watch: {
      value(newVal) {
        this.selectValue = newVal
      }
    },
    mounted: function() {

    }
  }
</script>

<style>
</style>
